'use client';

import { initializeNativeGeolocationHost } from './map/internal/utils/initializeNativeGeolocationHost';

if (typeof window !== 'undefined') {
  initializeNativeGeolocationHost();
}

/**
 * Runs native geolocation host bootstrap as early as the client bundle loads.
 * Renders nothing; safe to mount once at the app root.
 */
export function NativeGeolocationHostBootstrap(): null {
  return null;
}
